<template>
  <div class="container" v-loading.fullscreen.lock="fullscreenLoading">
    <el-form ref="form" class="filter-container" :inline="true">
      <el-form-item label="餐厅">
        <el-select
          size="mini"
          required
          :clearable="false"
          style="width: 150px"
          class="filter-item"
          value-key="canteen_id"
          v-model="listQuery.canteen"
          @change="getMachineList"
          placeholder="餐厅选择"
        >
          <el-option
            v-for="canteen in canteenList"
            :key="canteen.canteen_id"
            :label="canteen.canteen_name"
            :value="canteen"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="机器">
        <el-select
          size="mini"
          required
          :clearable="false"
          style="width: 90px"
          class="filter-item"
          value-key="machine_id"
          v-model="listQuery.machine"
          placeholder="机器选择"
        >
          <el-option
            v-for="machine in machineOptions"
            :key="machine.machine_id"
            :label="machine.machine_name"
            @change="handleFilter"
            :value="machine"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="日期">
        <el-date-picker
          size="mini"
          required
          :clearable="false"
          v-model="listQuery.daterange"
          type="daterange"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd"
          @change="handleFilter"
          :default-time="['00:00:00', '23:59:59']"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="餐时">
        <el-select
          required
          :clearable="false"
          size="mini"
          style="width: 90px"
          class="filter-item"
          value-key="name"
          v-model="listQuery.meal"
          placeholder="饭时选择"
          @change="handleFilter"
        >
          <el-option
            v-for="meal in mealOptions"
            :key="meal.index"
            :label="meal.name"
            :value="meal"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          class="filter-item"
          type="primary"
          v-waves
          size="mini"
          icon="el-icon-search"
          @click="handleFilter"
          >查询</el-button
        >
      </el-form-item>
      <!--<el-button class="filter-item" type="primary" v-waves icon="el-icon-search" @click="handleAdd">添加记录</el-button>-->
      <el-form-item>
<!--        <span v-else>下载</span>-->
        <el-tag type="success" v-if="generate"><i class="el-icon el-icon-loading"></i>报表生成中..</el-tag>
        &nbsp;
        <el-button
          download="Acme Documentation (ver. 2.0.1).txt"
          class="filter-item"
          type="primary"
          :loading="downloadLoading"
          v-waves
          size="mini"
          icon="el-icon-download"
          @click="handleDownload"
          >
          <span v-if="!generate">统计报表导出</span>
          <span v-else>下载</span>
        </el-button>
      </el-form-item>
      <el-form-item v-if="showRecord">
        <el-button
          type="primary"
          @click="showRecord = !showRecord"
          size="mini"
          icon="el-icon-search"
        >
          查看统计结果
        </el-button>
      </el-form-item>
      <el-form-item v-else>
        <el-button
          size="mini"
          type="primary"
          @click="showRecord = !showRecord"
          icon="el-icon-search"
          >查看详细记录</el-button
        >
      </el-form-item>
    </el-form>
    <div class="table-header">
      <p class="table-title" v-if="showRecord">
        用餐信息详情
        <a href="#" class="table-subtitle" @click="showRecord = false"
          >查看菜品销售汇总</a
        >
      </p>
      <p class="table-title" v-else>
        销量汇总
        <a href="#" class="table-subtitle" @click="showRecord = true"
          >查看用餐信息详情</a
        >
      </p>
      <span class="badge-wrapper">
        <el-badge class="mark" :value="summary.customer_sum">
          <el-tag size="mini" type="primary">总人数</el-tag>
        </el-badge>
        &nbsp;&nbsp;&nbsp;
        <el-badge class="mark" :value="dishCount">
          <el-tag type="warning" size="mini">总盘数</el-tag>
        </el-badge>
        &nbsp;&nbsp;&nbsp;
        <el-badge class="mark" :value="summary.price_sum.toFixed(2)">
          <el-tag type="danger" size="mini">总销售额</el-tag>
        </el-badge>
      </span>
    </div>
    <div v-show="showRecord" class="table">
      <vv-table :config="tabeConfig" :data="list" :minWidth="100" :height="700">
        <template slot-scope="scope" slot="date_slot">
          {{ scope.row.datetime }}
        </template>
        <template slot-scope="scope" slot="event_slot">
          <el-button @click="handleDetails(scope.row)" type="text" size="mini"
            >查看详情</el-button
          >
        </template>
      </vv-table>
      <el-dialog title="菜品详情" :visible.sync="dialogTableVisible">
        <el-table :data="currentRecordDetails">
          <el-table-column
            property="name"
            label="菜名"
            width="200"
          ></el-table-column>
          <el-table-column
            property="price"
            label="价格"
            width="200"
          ></el-table-column>
        </el-table>
      </el-dialog>
      <el-dialog
        title="菜单详情"
        :visible="recordFormVisible"
        :before-close="handleCancel"
      >
        <el-form :model="recordForm" :rules="formRules1">
          <el-form-item label="饭时" :label-width="formLabelWidth" prop="meal">
            <el-select
              v-model="recordForm.meal"
              value-key="name"
              placeholder="请选择"
            >
              <el-option
                v-for="meal in mealOptions1"
                :key="meal.index"
                :label="meal.name"
                :value="meal.index"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="用餐时间"
            :label-width="formLabelWidth"
            prop="datetime"
          >
            <el-date-picker
              value-format="yyyy-MM-dd hh:mm:ss"
              v-model="recordForm.datetime"
              type="datetime"
              placeholder="选择日期时间"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="详情" :label-width="formLabelWidth">
            <el-dialog
              width="70%"
              title="内层 Dialog"
              :visible.sync="innerVisible"
              append-to-body
            >
              <el-form el-form :model="recordDetail" :rules="formRules2">
                <el-form-item
                  label="菜名"
                  :label-width="formLabelWidth"
                  prop="name"
                >
                  <el-input
                    v-model="recordDetail.name"
                    auto-complete="off"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="价格"
                  :label-width="formLabelWidth"
                  prop="price"
                >
                  <el-input
                    v-model.number="recordDetail.price"
                    auto-complete="off"
                  ></el-input>
                </el-form-item>
              </el-form>
              <el-button type="primary" @click="addRecordDetail"
                >确认添加</el-button
              >
              <el-button type="primary" @click="innerVisible = false"
                >取消</el-button
              >
            </el-dialog>
            <el-button type="primary" @click="innerVisible = true"
              >添加详情</el-button
            >
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="handleCancel">取 消</el-button>
          <el-button type="primary" @click="handleUpload">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <div v-show="!showRecord">
      <!--      <div-->
      <!--        v-if="foodList.length <= 15 && foodList.length > 0"-->
      <!--        class="echarts-wrapper">-->
      <!--        &lt;!&ndash;<echartsBar :food-list="foodList" name="echarts1" title="最受欢迎的菜品" color="#3398DB"></echartsBar>&ndash;&gt;-->
      <!--        <p v-if="foodList.length" class="chart-title">最受欢迎的菜品top15</p>-->
      <!--        <div id="echarts1" class="echarts"></div>-->
      <!--      </div>-->
      <el-row
        :gutter="20"
        class="echarts-wrapper"
        v-if="foodList.length <= 15 && foodList.length > 0"
      >
        <el-col :span="8" :offset="1" class="wrapper">
          <chartWrapper
            :food-list="foodList"
            class="chart-left"
            title="最受欢迎的菜品"
            color="#c62f2f"
          ></chartWrapper>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="echarts-wrapper" v-else>
        <el-col :span="14" class="wrapper">
          <chartWrapper
            :food-list="top10"
            class="chart-left"
            title="最受欢迎的菜品top10"
          ></chartWrapper>
        </el-col>
        <el-col :span="8" :offset="1" class="wrapper">
          <chartWrapper
            :food-list="last5"
            class="chart-right"
            title="最不受欢迎的菜品top5"
            color="#c62f2f"
          ></chartWrapper>
        </el-col>
      </el-row>

      <!--      <div-->
      <!--        v-if="foodList.length > 15 && foodList.length > 0"-->
      <!--        style="width: 100%"-->
      <!--        class="echarts-wrapper"-->
      <!--      >-->
      <!--            </div>-->
      <!--        <div class="chart-left">-->
      <!--&lt;!&ndash;          <p class="chart-title">最受欢迎的菜品top10</p>&ndash;&gt;-->
      <!--&lt;!&ndash;          &lt;!&ndash;<echartsBar class="chart-left" :food-list="top10" name="echarts2" title="最受欢迎的菜品top10" colorcolor="#3398DB"></echartsBar>&ndash;&gt;&ndash;&gt;-->
      <!--&lt;!&ndash;          <div id="echarts2" class="echarts"></div>&ndash;&gt;-->
      <!--        </div>-->
      <!--        <div class="chart-right">-->
      <!--          <p class="chart-title">最不受欢迎的菜品top5</p>-->
      <!--          &lt;!&ndash;<echartsBar class="chart-right" :food-list="last5" name="echarts3" title="最不受欢迎的菜品top5" color="#c23531"></echartsBar>&ndash;&gt;-->
      <!--          <div id="echarts3" class="echarts"></div>-->
      <!--        </div>-->

      <div class="table">
        <el-table
          :data="foodListFilter"
          border
          fit
          style="width:100%;text-align: center;"
          v-loading="listLoading"
        >
          <el-table-column prop="name" label="菜名" align="center">
          </el-table-column>
          <el-table-column label="单价" align="center">
            <template slot-scope="scope">
              {{ scope.row.singlePrice || '0.00' }}
            </template>
          </el-table-column>
          <el-table-column prop="image" label="示例图片" align="center">
            <template slot-scope="scope">
              <img
                :src="
                  scope.row.image ||
                    'http://eatery.oss-cn-hangzhou.aliyuncs.com/330441894053393762.jpg'
                "
                alt=""
                width="30"
                height="30"
              />
            </template>
          </el-table-column>
          <el-table-column prop="num" label="数量" align="center">
          </el-table-column>
          <el-table-column label="总价" prop="price" align="center">
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import waves from '@/directive/waves' // 水波纹指令
import qs from 'qs'
import _ from 'lodash'
import FileSaver from 'file-saver'
import chartWrapper from './chartWrapper'
import vvTable from 'vue-virtual-table'
import moment from 'moment'
import {
  apiSaleRecordQuery,
  apiGetSummarySheet,
  apiGetMachineList,
  apiSalerecordGenerateSheet,
  apiSalerecordDetailQuery,
  apiSalerecordAdd
} from '@/api'
// import echartsBar from '../components/echartsBar'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'

Date.prototype.addDays = function (days) {
  var date = new Date(this.valueOf())
  date.setDate(date.getDate() + days)
  return date
}

function getDates (startDate, stopDate) {
  console.log(startDate, stopDate)
  startDate = startDate.addDays(1)
  stopDate = stopDate.addDays(1)
  var dateArray = new Array()
  var currentDate = startDate
  while (currentDate <= stopDate) {
    dateArray.push(new Date(currentDate))
    currentDate = currentDate.addDays(1)
  }
  return dateArray
}

export default {
  name: 'salesRecord',
  directives: {
    waves
  },
  components: {
    chartWrapper,
    vvTable
  },
  data () {
    return {
      generate: false,
      fullscreenLoading: true,
      echarts1: {},
      echarts2: {},
      echarts3: {},
      foodList: [],
      summary: '',
      showRecord: false,
      innerVisible: false,
      defaultForm: {
        meal: '1',
        datetime: '2018-09-03 12:58:59',
        record: [],
        price: '20'
      },
      formRules1: {
        meal: [{ required: true, trigger: 'blur' }],
        datatime: [{ required: true, trigger: 'blur' }]
      },
      formRules2: {
        price: [{ required: true, trigger: 'blur' }],
        name: [{ required: true, trigger: 'blur' }]
      },
      recordDetail: {},
      recordForm: {},
      recordFormVisible: false,
      dialogTableVisible: false,
      currentRecordDetails: null,
      tableKey: 0,
      list: null,
      total: null,
      listLoading: true,
      formLabelWidth: '120px',
      listQuery: {
        page: 1,
        limit: 20,
        canteen: {},
        machine: { machine_id: -1, machine_name: '全部' },
        meal: { index: -1, name: '全部' },
        daterange: [
          new Date(new Date().toDateString()),
          new Date(new Date().toDateString())
        ],
        type: undefined,
        sort: '+id'
      },
      machineOptions: [{ machine_id: -1, machine_name: '全部' }],
      mealOptions1: [
        { index: '1', name: '早饭' },
        { index: '2', name: '午饭' },
        { index: '3', name: '晚饭' }
      ],
      mealOptions: [
        { index: -1, name: '全部' },
        { index: 1, name: '早饭' },
        { index: 2, name: '午饭' },
        { index: 3, name: '晚饭' }
      ],
      downloadLoading: false
    }
  },
  filters: {
    statusFilter (status) {
      const statusMap = {
        published: 'success',
        draft: 'info',
        deleted: 'danger'
      }
      return statusMap[status]
    },
    parseDate (datetime) {
      return datetime.split(' ')[0]
    },
    parseTime (datetime) {
      return datetime.split(' ')[1]
    }
  },
  mounted () {
    /**
     * 从上个界面接收到的api_key
     */
    console.log('this.$route.params', this.$route.query)
    // this.api_key = this.$route.query.api_key
    this.recordDetail = {}
    this.recordForm = {}
    // this.getCanteenList()
    this.listQuery.canteen = this.canteenList[0]
    this.getMachineList()
    this.handleFilter()
    let self = this
    window.onresize = function () {
      self.echarts1.resize && self.echarts1.resize()
      self.echarts2.resize && self.echarts2.resize()
      self.echarts3.resize && self.echarts3.resize()
    }
  },
  methods: {
    addRecordDetail () {
      this.innerVisible = false
      this.recordForm.record.push(this.recordDetail)
      this.recordDetail = {}
      console.log(this.recordDetail)
    },
    handleAdd () {
      this.recordFormVisible = true
      this.recordForm = _.cloneDeep(this.defaultForm)
    },
    handleUpload () {
      this.recordFormVisible = false
      this.addRecord()
    },
    handleCancel () {
      this.reordFormVisible = false
      this.recordForm = {}
    },
    async getDetails (record_id) {
      try {
        const res = await apiSalerecordDetailQuery(
          qs.stringify({ record_id: record_id })
        )
      let Details = res
      Details.forEach((Detail,index,Details) => {
        //console.log('Detail.name',Detail.name)
        //console.log('Detail.price',Detail.price)
        Details[index].price=parseFloat(Detail.price).toFixed(2)
        Details[index].name=Detail.name
      });
        //console.log(Details[0].name)
        //console.log(Details[0].price)
        
        this.currentRecordDetails = Details
      } catch (e) {
        this.$message.error('获取失败' + e.message)
      }
      // this.$http
      //   .post(
      //     `${this._host}salerecord/detail/query/`,
      //     qs.stringify({ record_id: record_id }),
      //     {
      //       headers: {
      //         'api-key': this.api_key,
      //         'Content-Type': 'application/x-www-form-urlencoded'
      //       }
      //     },
      //     { emulateHTTP: true }
      //   )
      //   .then(res => {
      //     this.currentRecordDetails = res.body.data
      //   })
      //   .catch(e => {})
    },
    handleDetails (row) {
      // console.log(row.record_id);
      this.getDetails(row.record_id)
      // this.$router.push({path: '/main/recordDetails', query: {api_key: this.api_key, record_id: row.record_id}});
      this.dialogTableVisible = true
    },
    async addRecord () {
      console.log(this.recordForm.datetime)
      // this.recordForm.datetime = this.recordForm.datetime.replace(/\w/g, ' ')
      try {
        await apiSalerecordAdd(
          JSON.stringify(this.recordForm),
          this.listQuery.machine.machine_id.toString()
        )
        this.recordForm = _.cloneDeep(this.defaultForm)
        this.recordDetail = {}
      } catch (e) {
        this.recordDetail = {}
      }
    },
    async getMachineList () {
      this.listLoading = true
      try {
        let machines = await apiGetMachineList(
          this.listQuery.canteen.canteen_id.toString()
        )
        console.log(machines)
        this.machineOptions = machines.concat({
          machine_id: -1,
          machine_name: '全部'
        })
        this.handleFilter()
      } catch (e) {
        this.listLoading = false
        this.$message.error('获取机器列表失败' + e.message)
      }
    },
    async handleFilter () {
      this.fullscreenLoading = true
      let { machine, meal, daterange } = this.listQuery
      let machine_id_list = []
      if (machine.machine_id == -1) {
        machine_id_list = this.machineOptions
          .filter(machineO => machineO.machine_id >= 0)
          .map(machineO => machineO.machine_id)
      } else {
        machine_id_list = [machine.machine_id]
      }
      let meal_index_list = []
      if (meal.index == -1) {
        meal_index_list = this.mealOptions
          .filter(mealO => mealO.index >= 0)
          .map(mealO => mealO.index)
      } else {
        meal_index_list = [meal.index]
      }
      let dates = getDates(daterange[0], daterange[1])
      daterange = dates.map(date => date.toISOString().slice(0, 10))
      try {
        this.listLoading = true
        const res = await apiSaleRecordQuery(
          qs.stringify({
            meal_filter: JSON.stringify(meal_index_list),
            date_filter: JSON.stringify(daterange),
            machine_filter: JSON.stringify(machine_id_list)
          })
        )
        this.fullscreenLoading = false
        //console.log('res',res)
        let Details = res
        Details.forEach((Detail,index,Details) => {
        //console.log('Detail.price_sum',Detail.price_sum)
        Details[index].price_sum=parseFloat(Detail.price_sum).toFixed(2)
      });
        this.list = Details
      } catch (e) {
        this.$message.error('查询失败' + e.message)
        this.fullscreenLoading = false
      }
      try {
        this.listLoading = true
        const res = await apiGetSummarySheet(
          qs.stringify({
            meal_filter: JSON.stringify(meal_index_list),
            date_filter: JSON.stringify(daterange),
            machine_filter: JSON.stringify(machine_id_list)
          })
        )
        this.listLoading = false
        this.summary = res

        this.foodList = res.food
      } catch (e) {
        this.$message.error('查询summary失败' + e.message)
      }
    },
    async handleDownload () {
      let { machine, meal, daterange } = this.listQuery
      let machine_id_list = []
      // console.log(machine, this.machineOptions)
      if (machine.machine_id === -1) {
        machine_id_list = this.machineOptions
          .filter(machineO => machineO.machine_id >= 0)
          .map(machineO => machineO.machine_id)
      } else {
        machine_id_list = [machine.machine_id]
      }
      //console.log(machine_id_list)
      let meal_index_list = []
      if (meal.index === -1) {
        meal_index_list = this.mealOptions
          .filter(mealO => mealO.index >= 0)
          .map(mealO => mealO.index)
      } else {
        meal_index_list = [meal.index]
      }
      daterange.map(a => moment(a).format('YYYY-MM-DD'))
      try {
        const res = await apiSalerecordGenerateSheet({
          meal_filter: meal_index_list,
          date_filter: daterange.map(a => moment(a).format('YYYY-MM-DD')),
          machine_filter: machine_id_list
        })
        //console.log('apiSalerecordGenerateSheet',res)
        const content = res.data
        //console.log(content.size)
        if (content.size < 100) {
          this.generate = true
          //循环获取避免不知道应该什么时候下载
          this.handleDownload ()
          //this.$message.error('正在生成报表, 请稍后下载')
        } else {
          this.generate = false
          // this.$message.error('正在生成报表, 请稍后下载')
          FileSaver.saveAs(new Blob([content]), '汇总表.xlsx')
        }
        // const elink = document.createElement('a')
        // elink.download = '汇总表.xls'
        // elink.style.display = 'none'
        // elink.href = URL.createObjectURL(content)
        // document.body.appendChild(elink)
        // elink.click()
        // URL.revokeObjectURL(elink.href) // 释放URL 对象
        // document.body.removeChild(elink)
      } catch (e) {
        console.log(e)
        this.$message.error()
      }
      // this.$http
      //   .post(
      //     `https://enterprise.zhihuituancan.com/apiv1/salerecord/generate_sheet/`,
      //     qs.stringify({
      //       meal_filter: JSON.stringify(meal_index_list),
      //       date_filter: JSON.stringify(daterange),
      //       machine_filter: JSON.stringify(machine_id_list)
      //     }),
      //     {
      //       responseType: 'blob',
      //       headers: {
      //         'api-key': this.api_key,
      //         'Content-Type': 'application/x-www-form-urlencoded'
      //       }
      //     },
      //     { emulateHTTP: true }
      //   )
      //   .then(res => {
      //     console.log('res', res)
      //     const content = res.bodyBlob
      //     const blob = new Blob([content])
      //     const elink = document.createElement('a')
      //     elink.download = '汇总表.xls'
      //     elink.style.display = 'none'
      //     elink.href = URL.createObjectURL(blob)
      //     document.body.appendChild(elink)
      //     elink.click()
      //     URL.revokeObjectURL(elink.href) // 释放URL 对象
      //     document.body.removeChild(elink)
      //
      //     //          a = document.createElement('a');
      //     // a.href = window.URL.createObjectURL( res.body);
      //     // // Give filename you wish to download
      //     // a.download = "test-file.xls";
      //     // a.style.display = 'none';
      //     // document.body.appendChild(a);
      //     // a.click();
      //   })
      //   .catch(e => {$ht
      //     this.listLoading = false
      //   })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          if (j === 'timestamp') {
            return parseTime(v[j])
          } else {
            return v[j]
          }
        })
      )
    }
  },
  computed: {
    tabeConfig () {
      return [
        { prop: 'record_id', name: '订单号', width: 100 },
        { prop: '_action', name: '订单时间', actionName: 'date_slot' },
        { prop: 'price_sum', name: '总价' },
        { prop: '_action', name: '详情', actionName: 'event_slot' }
      ]
    },
    foodListFilter () {
      let list = this.foodList
      //console.log('foodList1',list)
      list.sort((a, b) => b.num - a.num)
      list.forEach(a => {
        this.$set(a, 'singlePrice', (a.price / a.num).toFixed(2))
        this.$set(a, 'price', (a.price).toFixed(2))
      })
      //console.log('foodList2',list)
      return list
    },
    dishCount () {
      let count = 0
      this.foodListFilter.forEach(({ num }) => {
        count += num
      })
      return count
    },
    top10 () {
      return this.foodList.length > 15 ? this.foodList.slice(0, 10) : []
    },
    userinfo () {
      return this.$store.getters.userinfo()
    },
    canteenList () {
      return this.$store.getters.canteenList()
    },
    api_key () {
      return this.userinfo.api_key
    },
    last5 () {
      return this.foodList.length > 15 ? this.foodList.slice(-5).reverse() : []
    }
  },
  watch: {
    showRecord: function () {
      this.fullscreenLoading = true
      setTimeout(() => {
        this.fullscreenLoading = false
      }, 1000)
    }
  }
}
</script>
<style scoped lang="scss">
.filter-item {
  display: inline-block;
}
.title {
  padding-left: 50px;
  font-size: 16px;
}

.title .strong-text {
  color: #3a8ee6;
}
.echarts-single-wrapper {
  width: 50%;
  height: 500px;
  padding-bottom: 100px;
}
.echarts-single-wrapper .echarts {
  width: 50%;
  height: 100%;
}
.echarts-wrapper {
  width: 100%;
  height: 300px;
  margin-bottom: 50px;
  .wrapper {
    height: 100%;
    .chart-right {
      width: 100%;
      height: 100%;
    }
    .chart-left {
      width: 100%;
      height: 100%;
    }
  }
}
.echarts-wrapper .echarts-single {
  width: 60%;
  height: 100%;
}

.chart-left {
  width: 60%;
  height: 100%;
}

.echarts {
  height: 100%;
}

.chart-title {
  position: relative;
  top: 50px;
  text-align: center;
}

.table-header {
  width: 100%;
  text-align: center;
  position: relative;
  z-index: 100;
  .badge-wrapper {
    position: absolute;
    display: inline-block;
    top: 0;
    left: 0;
  }
}

.table-title {
  font-size: 18px;
}

.table-subtitle {
  font-size: 12px;
  color: #409eff;
  text-decoration: none;
}
</style>
